import { PATHS } from '@src/consts'

export const entrancePathNames = [
  PATHS.SIGNIN,
  PATHS.DEACTIVATE_TFA,
  PATHS.RESET_PASSWORD,
  PATHS.INVOKE_REDIRECT_WEB,
]
